import styled from 'styled-components';

export const FilterViewContainer = styled.div<{ isContact?: number }>`
  display: flex;
  width: ${({ isContact }) => (isContact ? '100%' : '30%')};
  margin-right: auto;
  position: relative;
  align-items: center;
  button.filter {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
  button {
    margin: 0;
  }
  div.filter-view-name {
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    .fui-loader {
      margin-left: 8px;
    }
    & > :not(:last-child) {
      margin-right: 8px;
    }
    span {
      width: max-content;
    }
  }
  div.filter-view-popover-anchor {
    position: absolute;
    top: 40px;
    left: 50px;
  }
  & > :not(:last-child) {
    margin-right: 16px;
  }
  .filter-view {
    cursor: pointer;
  }
  .filter-view.close > path {
    stroke-width: 100px;
  }
`;

export const CustomFilterViewContainer = styled.div`
  background: #ffffff;
  min-height: 180px;
  max-height: 350px;
  width: 300px;
  font-size: 14px;
  z-index: 15;
  display: flex;
  padding: 20px;
  margin-top: 16px;
  border-radius: 6px;
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 3px, rgb(25 50 71 / 16%) 0px 4px 20px;
  flex-direction: column;

  .header {
    margin-bottom: 20px;
  }
  .filter-view-options {
    margin-top: auto;
    display: flex;
    justify-content: end;
  }
`;
